// extracted by mini-css-extract-plugin
export default {"main":"GeneratedAssetDetails_main__czdjZ"};